import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLoadServiceEvent from "../../app/assetloading/AssetLoadServiceEvent";

export default class LoadSplashAssetsTask extends Task {
    /**
     * Loads the correct directional variant of splash screen assets after language is determined
     * @param {soma.EventDispatcher} dispatcher 
     * @param {AssetLoadService} assetLoadService 
     * @param {AppModel} appModel 
     */
    constructor(dispatcher, assetLoadService, appModel) {
        super();

        this.execute = function(callback, progressCallback) {
            const handleProgress = (e) => {
                progressCallback(this, e.params.progress);
            };
            
            const handleLoadComplete = () => {
                dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_PROGRESS, handleProgress);
                dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, handleLoadComplete);
                callback(this);
            };

            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_PROGRESS, handleProgress);
            dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, handleLoadComplete);
            
            // Load only the correct directional variant based on language
            const splashAssetGroup = appModel.rtl ? "SplashAssets_RTL" : "SplashAssets";
            assetLoadService.loadGroups(splashAssetGroup);
        }
    }
}
